import { APP_BUSINESS_DOMAIN } from "src/constants/routes";

export const BUSINESS_USER_REGISTER = `${APP_BUSINESS_DOMAIN}/register`;
export const BUSINESS_USER_DASHBOARD = `${APP_BUSINESS_DOMAIN}/dashboard`;
export const BUSINESS_USER_PROJECT = `${APP_BUSINESS_DOMAIN}/project`;
export const BUSINESS_USER_PROJECT_CANDIDATE = `${BUSINESS_USER_PROJECT}/:company_project_id`;
